<template>
  <div>
    <el-dialog
      top="1%"
      title="表单详情"
      :visible.sync="editFormApplyOpen"
      width="90%"
    >
      <el-button
        type="primary"
        @click="ExportFile(FormApply)"
        style="float: right; margin-bottom: 5px"
        >打印导出</el-button
      >
      <hr />
      <el-row class="decrad">
        <el-col :span="10" :offset="0" style="height: 90vh">
          <div style="display: flex;justify-content: space-between;">
            <el-button type="text" @click="lookForm(FormApplyFields)">
              <i class="el-icon-view"></i>查看表单内容
            </el-button>
          </div>
          <iframe
            :src="this.$store.state.baseUrl + FormApply.famp06"
            width="100%"
            height="100%"
            frameborder="0"
          ></iframe>
        </el-col>
        <el-col :span="7" :offset="0" style="padding-left: 10px">
          <div class="middle">
            <el-card class="box-card" shadow="never" style="height: 45vh">
              <div slot="header" class="clearfix">
                <span style="font-size: 18px; font-weight: bold">协同流程</span>
              </div>
              <div
                style="height: 35vh; overflow: auto; background-color: #f3f5f6"
              >
                <div
                  style="margin-left: 10%; margin-top: 8%; width: 80%"
                  v-for="(item, index) in FormAuditFlow.filter(
                    (ele) => ele.fmad07 == 1
                  )"
                  :key="index"
                >
                  <el-card class="box-card" shadow="always">
                    <p style="color: #527cfa" v-if="item.fmad05 == 1">会签</p>
                    <p style="color: #527cfa" v-else>或签</p>
                    <div class="card-cont">
                      <h4>步骤{{ item.fmad06 }}（{{ item.fmad03 }}）</h4>
                      <span>{{ item.name }}</span>
                    </div>
                  </el-card>
                  <i
                    v-if="
                      index !=
                        FormAuditFlow.filter((ele) => ele.fmad07 == 1).length -
                          1
                    "
                    class="el-icon-bottom"
                  ></i>
                </div>

                <div
                  style="margin-left: 5%; margin-top: 8%; width: 80%"
                  class="el-card__body"
                  v-for="(item, index) in FormAuditFlow.filter(
                    (ele) => ele.fmad07 == 2
                  )"
                  :key="item.fmad01"
                >
                  <el-card class="card-son" shadow="always">
                    <p style="color: #527cfa">抄送人员</p>
                    <div class="card-cont">
                      <span>{{ item.name }}</span>
                    </div>
                  </el-card>
                </div>
              </div>
            </el-card>
            <el-card
              class="box-card goutong"
              shadow="never"
              style="height: 49vh"
            >
              <div slot="header" class="clearfix">
                <span style="font-size: 18px; font-weight: bold">沟通记录</span>
              </div>
              <el-row>
                <el-col :span="19">
                  <el-input
                    placeholder="请输入内容"
                    v-model="talkSafe"
                    clearable
                    disabled
                  >
                  </el-input>
                </el-col>
                <el-col :span="3" :offset="1">
                  <el-button type="primary" @click="talkhanld">评论</el-button>
                </el-col>
              </el-row>
              <div style="height: 36vh; overflow: auto; margin-top: -20px">
                <div
                  v-for="(item, index) in safeList"
                  :key="index"
                  class="text item"
                >
                  <el-card
                    class="box-card"
                    style="margin: 0 auto; width: 90%; margin-top: 20px"
                  >
                    <el-row>
                      <el-col :span="4">
                        <el-avatar
                          v-if="item.imgurl"
                          :size="50"
                          :src="$store.state.baseUrl + item.imgurl"
                        ></el-avatar>
                        <el-avatar
                          v-else
                          src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
                        ></el-avatar>
                      </el-col>
                      <el-col :span="19" :offset="1">
                        <div>
                          <span style="font-size: 18px; font-weight: bold">{{
                            item.Username
                          }}</span>
                          <span
                            style="font-size: 12px; margin-left: 20px; color: #a6a6a6"
                            >{{ item.fscd05 }}</span
                          >
                        </div>
                        <div style="margin-top: 8px">{{ item.fscd03 }}</div>
                        <div>
                          <el-popconfirm
                            v-show="item.fscd04 == talkId"
                            confirm-button-text="好的"
                            cancel-button-text="不用了"
                            icon="el-icon-info"
                            icon-color="red"
                            title="确定删除吗？"
                            @confirm="delTalk(item.fscd01)"
                          >
                            <el-button
                              type="text"
                              slot="reference"
                              style="float: right; color: #909399"
                              >删除</el-button
                            >
                          </el-popconfirm>
                          <!-- <el-button
                        type="text"
                        style="float: right;margin-right:10px"
                        @click="addTalk"
                        >评论</el-button
                      > -->
                        </div>
                      </el-col>
                    </el-row>
                  </el-card>
                </div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :span="7" :offset="0">
          <el-card class="box-card" shadow="never" style="margin-top: -20px">
            <div slot="header" class="clearfix">
              <span style="font-size: 18px; font-weight: bold">动态记录</span>
            </div>
            <div style="height: 83vh; overflow: auto">
              <!-- 内容 -->
              <el-timeline>
                <el-timeline-item
                  v-for="(activity, index) in FormAuditRecord"
                  :key="index"
                  :icon="activity.icon"
                  :type="activity.type"
                  :color="activity.color"
                  :size="activity.size"
                  :timestamp="activity.farc05"
                >
                  <p>
                    {{ activity.farc03 }}
                    <el-button
                      style="margin-left: 100px"
                      type="primary"
                      size="mini"
                      @click="(bhUrl = null), (bhUrl = activity.farc07)"
                      v-if="activity.farc07"
                      >查看</el-button
                    >
                  </p>
                  <p v-if="activity.farc06" style="margin-top: 10px">
                    审批内容：{{ activity.farc06 }}
                  </p>
                </el-timeline-item>
              </el-timeline>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 查看驳回文件 -->
    <el-dialog title="驳回文档" :visible.sync="bhUrl" width="50%" top="5%">
      <iframe
        v-if="bhUrl"
        :src="this.$store.state.baseUrl + bhUrl"
        width="100%"
        height="700px"
        frameborder="0"
      ></iframe>
    </el-dialog>
    <!-- 查看表单内容 -->
    <el-dialog :visible.sync="lookFormShow" width="40%">
      <el-row>
        <el-descriptions class="margin-top" :column="1" border>
          <el-descriptions-item
            v-for="(item, index) in lookFromFields"
            :key="index"
            label="用户名"
          >
            <template slot="label">{{ item.fafd05 }}</template>
            <!-- 根据 要填写的类型不同，所需要填写的组建不同 -->
            <!-- 占用 02 -->
            <!-- 时间 -->
            <!-- 文本-->
            <el-input
              v-if="
                (item.fafd03 == 1 ||
                  item.fafd03 == 4 ||
                  item.fafd03 == 5 ||
                  item.fafd03 == 7 ||
                  item.fafd03 == 8) &&
                  item.fafd06 != null
              "
              v-model="item.fafd06"
              :disabled="true"
            ></el-input>
            <!-- 附件 9-->
            <p v-else-if="item.fafd03 == 9 && item.fafd06 != null">
              {{ item.fafd06.slice(item.fafd06.lastIndexOf("/") + 1) }}
              <el-button
                @click="Office2Pdf(item)"
                size="small"
                type="primary"
                plain
                >查看</el-button
              >

              <el-button
                @click="
                  downLoad(
                    item.fafd06,
                    item.fafd06.slice(item.fafd06.lastIndexOf('/') + 1)
                  )
                "
                size="small"
                type="primary"
                plain
                >下载</el-button
              >
            </p>
            <!-- 表单编号 -->
            <el-input
              v-else-if="item.fafd03 == 4 && item.fafd06 != null"
              v-model="item.fafd06"
              :disabled="true"
            ></el-input>
            <!-- 图片 -->
            <img
              v-else-if="
                (item.fafd03 == 12 || item.fafd03 == 10 || item.fafd03 == 11) &&
                  item.fafd06 != null
              "
              style="width: 320px; height: 240px"
              :src="$store.state.baseUrl + item.fafd06"
              alt=""
              srcset=""
            />
            <!-- 视频 -->
            <video
              v-else-if="item.fafd03 == 3 && item.fafd06 != null"
              width="320"
              height="240"
              controls
              autoplay
              :src="$store.state.baseUrl + item.fafd06"
            ></video>
            <!-- 音频 -->
            <audio
              v-else-if="item.fafd03 == 2 && item.fafd06 != null"
              :src="$store.state.baseUrl + item.fafd06"
              controls="controls"
            ></audio>
            <!-- 人员 -->
            <el-input
              v-else-if="item.fafd03 == 7 && item.fafd06 != null"
              v-model="item.fafd06"
              :disabled="true"
            ></el-input>
            <el-input
              v-else-if="item.fafd03 == 6 && item.fafd06 != null"
              v-model="item.fafd06"
              :disabled="true"
            ></el-input>
            <el-input
              v-else-if="item.fafd03 == 8 && item.fafd06 != null"
              v-model="item.fafd06"
              :disabled="true"
            ></el-input>
            <span v-else style="color: #909399; margin-left: 10px"
              >未上传数据</span
            >
          </el-descriptions-item>
        </el-descriptions>
      </el-row>
    </el-dialog>
    <el-dialog :visible.sync="ifromShow" width="40%" title="查看附件">
      <iframe style="width: 100%; height: 65vh" :src="fileLike"></iframe>
    </el-dialog>
  </div>
</template>
<script>
import { download } from "@/tools/tool";
import { FindFormApplyDetail, GetFormComment, Office2Pdf } from "@/setAxios";
export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      editFormApplyOpen: false,
      // 详情数据
      FormApply: {},
      FormAuditFlow: [],
      FormApplyFields: [],
      FormAuditRecord: [],
      ApplyFieldsInfo: {},
      //   评论
      talkSafe: "",
      safeList: [],
      talkId: 0, //判断id
      activities: [
        {
          content: "支持使用图标",
          timestamp: "2018-04-12 20:46",
          size: "large",
          type: "primary",
          icon: "el-icon-more",
        },
        {
          content: "支持自定义颜色",
          timestamp: "2018-04-03 20:46",
          color: "#0bbd87",
        },
        {
          content: "支持自定义尺寸",
          timestamp: "2018-04-03 20:46",
          size: "large",
        },
        {
          content: "默认样式的节点",
          timestamp: "2018-04-03 20:46",
        },
      ],
      // 查看表单内容
      lookFormShow: false,
      lookFromFields: [], // 表单内容数据
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      id: null,
      bhUrl: null,
      ifromShow: false, // 附件
      fileLike: null,
    };
  },
  computed: {},
  watch: {},
  methods: {
    async Office2Pdf(data) {
      let res = await Office2Pdf({ sourcePath: data.fafd06 });
      if (res.Code === 0) {
        this.$message({
          type: "warning",
          message: res.Message,
        });
      } else {
        this.ifromShow = true;
        this.fileLike = this.$store.state.baseUrl + res.Data;
      }
    },
    downLoad(path, name) {
      try {
        download(
          this.$store.state.baseUrl + path,
          name + path.substr(path.lastIndexOf("."))
        );
      } catch (error) {
        this.$message.error("导出失败");
      }
    },
    open() {
      this.FindFormApplyDetail(this.id);
      this.GetFormComment(this.id);
      this.editFormApplyOpen = true;
    },
    async FindFormApplyDetail(id) {
      let params = {
        id,
      };
      let res = await FindFormApplyDetail({ params });
      console.log(res.Data);
      if (res.Code > 0) {
        this.FormApply = res.Data.FormApply;
        this.FormApplyFields = res.Data.FormApplyFields;
        this.FormAuditFlow = res.Data.FormAuditFlow;
        this.FormAuditRecord = res.Data.FormAuditRecord;
        this.FormAuditRecord.forEach((ele) => {
        if (ele.farc04 == "2" || ele.farc04 == "3") {
          ele.size = "large";
          ele.type = "danger";
          ele.icon = "el-icon-circle-close";
        } else {
          ele.size = "large";
          ele.type = "primary";
          ele.icon = "el-icon-circle-check";
        }
      });
      }
    },
    handleClose() {},
    ExportFile() {},
    lookForm(FormApplyFields) {
      console.log(FormApplyFields);
      this.lookFormShow = true;
      this.lookFromFields = FormApplyFields;
    },
    // 获取安全清单评论列表
    async GetFormComment(id) {
      let params = {
        id,
      };
      let res = await GetFormComment({ params });
      this.safeList = res.Data;
      let datestr = new Date().format("yyyy-MM-dd hh:mm");
      this.safeList.forEach((e) => {
        if (datestr == e.fscd05.toString().substring(0, 10)) {
          e.fscd05 =
            "今天" + e.fscd05.toString().substring(11, e.fscd05.length);
        }
      });
    },
    talkhanld() {},
    delTalk() {},
    showForm(data) {},
    handleSizeChange() {},
    handleCurrentChange() {},
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
};
</script>
<style lang="less" scoped>
/deep/ .decrad .el-card__header {
  border-bottom: none;
  padding-bottom: 8px;
}
/deep/.el-table .warning-row {
  background: skyblue;
}
/deep/ .decrad .el-card {
  border: none;
}
/deep/ .goutong .el-card__body {
  padding: 0px;
}
.middle {
  margin-top: -30px;
  padding-top: 10px;
  border-left: 1px solid #e6e6e6;
  border-right: 1px solid #e6e6e6;
  height: 90vh;
}
.card-cont {
  text-align: center;
  margin-top: 18px;
  span {
    color: #838383;
  }
}
.el-card__body {
  position: relative;
  padding: 20px;
  width: 35vh;
  .el-icon-bottom:before {
    content: "\E6EB";
    color: #5db3f0;
    font-size: 35px;
    position: relative;
    top: 3vh;
    margin-left: 15vh;
  }
}
/deep/.card-choice {
  height: 80vh !important;
  .card-son {
    p {
      color: #1177dc;
      font-size: 15px;
    }
  }
}
</style>
